import { api } from "./Assets/assetsShared";

export default api;